module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Tomek_Alicja.0827526c.jpg";